import React from "react";

import ReactJson from "react-json-view";

import { Empty } from "antd";

export interface ObjectViewerProps {
  data?: object | object[];
}

export const ObjectViewer: React.FC<ObjectViewerProps> = (props) => {
  const viewerProps = {
    displayObjectSize: false,
    displayDataTypes: false,
    enableClipboard: false,
    quotesOnKeys: false,
    displayArrayKey: false,
    name: null,
    shouldCollapse: (field: any) => field.name !== null,
  };

  if (props.data === undefined) return <Empty description={false} />;
  return <ReactJson {...viewerProps} src={props.data} />;
};
